import React from 'react'
import { useRecoilValue } from 'recoil'
import { loveInterestAtom } from '../../../../state/assessment'


export default function Index(props) {
  const loveInterest = useRecoilValue(loveInterestAtom);
  
  const loveInterestName = loveInterest?.loveInterest || "your love interest";
  const loveInterestImage = loveInterest?.loveInterest ? 
    `${process.env.PUBLIC_URL}/images/characters/${loveInterest.loveInterest}/${loveInterest.loveInterest}%208.png` : null;

  return (
    <div className="assessment1-container">
      <div className="assessment1-wrap">
        <div className="assessment1-title">
          Directions
        </div>
        {loveInterestImage && (
          <div style={{textAlign: 'center', margin: '20px 0'}}>
            <img 
              src={loveInterestImage} 
              alt={loveInterestName}
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '3px solid #F277C6'
              }}
            />
          </div>
        )}
        <div className="assessment1-content">
          Dessert is done. The guests are getting ready to leave and begin to get up to leave. {loveInterestName} gets up first and glances at you. You take your chance and ask for {loveInterestName}'s number and {loveInterestName} whispers it to you so the other guests don't notice. Your job in this
          module is to correctly input {loveInterestName}'s number after seeing it for 10 seconds. Make sure you're ready before clicking Get Started. The timer starts right away!
        </div>

        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get Started
        </div>
      </div>
    </div>
  )
}
